import { Skill } from './types'

export const SKILLS: Skill[] = [
  // ===== INSTALLED =====
  {
    id: 'pdf-extract',
    slug: 'pdf-extract',
    name: 'PDF Extract',
    version: '2.4.1',
    domain: 'Documents',
    description:
      'Extract text, tables, and images from PDF files. Handles OCR for scanned documents and preserves layout metadata.',
    stars: 1240,
    risk: 'medium',
    status: 'installed',
    sha256: 'a1b2c3d4e5f6789abc0123456789def0fedcba9876543210',
    author: 'clawhub/pdf-extract',
    lastUsed: '2 hours ago',
    icon: 'FileText',
    tools: [
      {
        name: 'extract_text',
        summary: 'Extract plain text from a PDF with optional page range',
        inputSchemaPreview: '{ file: string, pages?: string }',
        sideEffects: { reads: true },
        humanApprovalRequired: true,
      },
      {
        name: 'extract_tables',
        summary: 'Detect and extract tables as structured JSON',
        inputSchemaPreview: '{ file: string, format?: "json" | "csv" }',
        sideEffects: { reads: true },
        humanApprovalRequired: true,
      },
      {
        name: 'extract_images',
        summary: 'Extract embedded images and save them to the workspace',
        inputSchemaPreview: '{ file: string, outputDir: string }',
        sideEffects: { reads: true, writes: true },
        humanApprovalRequired: true,
      },
    ],
    audit: [
      { id: '1', tool: 'extract_text', invokedBy: 'workflow:invoice-processing', status: 'success', approvedBy: 'matt', durationMs: 842, timestamp: '2h ago' },
      { id: '2', tool: 'extract_tables', invokedBy: 'chat-agent', status: 'success', approvedBy: 'matt', durationMs: 1204, timestamp: 'yesterday' },
      { id: '3', tool: 'extract_images', invokedBy: 'chat-agent', status: 'success', approvedBy: 'matt', durationMs: 3102, timestamp: 'yesterday' },
      { id: '4', tool: 'extract_text', invokedBy: 'workflow:invoice-processing', status: 'success', approvedBy: 'matt', durationMs: 765, timestamp: '2 days ago' },
    ],
    versions: [
      { version: '2.4.1', approvedAt: '2026-04-02' },
      { version: '2.4.0', approvedAt: '2026-03-28' },
      { version: '2.3.5', approvedAt: '2026-03-10' },
    ],
  },
  {
    id: 'whisper-transcribe',
    slug: 'whisper-transcribe',
    name: 'Whisper Transcribe',
    version: '1.8.0',
    domain: 'Media',
    description:
      'Transcribe audio and video files using OpenAI Whisper. Supports 90+ languages, speaker diarization, and word-level timestamps.',
    stars: 2100,
    risk: 'low',
    status: 'installed',
    sha256: 'f0e1d2c3b4a5968778695a4b3c2d1e0fafedcba9876543210',
    author: 'clawhub/whisper-transcribe',
    lastUsed: 'yesterday',
    icon: 'Headphones',
    tools: [
      {
        name: 'transcribe',
        summary: 'Transcribe an audio or video file to text',
        inputSchemaPreview: '{ file: string, language?: string, diarize?: boolean }',
        sideEffects: { reads: true },
        humanApprovalRequired: true,
      },
    ],
    audit: [
      { id: '1', tool: 'transcribe', invokedBy: 'chat-agent', status: 'success', approvedBy: 'matt', durationMs: 12402, timestamp: 'yesterday' },
      { id: '2', tool: 'transcribe', invokedBy: 'workflow:podcast-sync', status: 'success', approvedBy: 'matt', durationMs: 8921, timestamp: '3 days ago' },
      { id: '3', tool: 'transcribe', invokedBy: 'chat-agent', status: 'success', approvedBy: 'matt', durationMs: 5543, timestamp: '1 week ago' },
    ],
    versions: [
      { version: '1.8.0', approvedAt: '2026-03-20' },
      { version: '1.7.2', approvedAt: '2026-02-14' },
    ],
  },
  {
    id: 'web-scrape-basic',
    slug: 'web-scrape-basic',
    name: 'Web Scrape',
    version: '3.1.2',
    domain: 'Web',
    description:
      'Fetch and parse web pages. Returns readable text, metadata, and links. Respects robots.txt and rate limits.',
    stars: 890,
    risk: 'high',
    status: 'installed',
    sha256: '1234567890abcdef1234567890abcdef1234567890abcdef',
    author: 'clawhub/web-scrape-basic',
    lastUsed: '3 days ago',
    icon: 'Globe',
    tools: [
      {
        name: 'fetch_page',
        summary: 'Fetch a URL and return its readable text content',
        inputSchemaPreview: '{ url: string, selector?: string }',
        sideEffects: { reads: true, network: true },
        humanApprovalRequired: true,
      },
      {
        name: 'fetch_metadata',
        summary: 'Extract Open Graph, Twitter Cards, and JSON-LD metadata',
        inputSchemaPreview: '{ url: string }',
        sideEffects: { reads: true, network: true },
        humanApprovalRequired: true,
      },
    ],
    audit: [
      { id: '1', tool: 'fetch_page', invokedBy: 'chat-agent', status: 'success', approvedBy: 'matt', durationMs: 2341, timestamp: '3 days ago' },
      { id: '2', tool: 'fetch_metadata', invokedBy: 'voice-agent', status: 'rejected', approvedBy: 'matt', durationMs: 0, timestamp: '4 days ago' },
    ],
    versions: [{ version: '3.1.2', approvedAt: '2026-03-18' }],
  },
  {
    id: 'markdown-summarise',
    slug: 'markdown-summarise',
    name: 'Markdown Summarise',
    version: '1.0.4',
    domain: 'Documents',
    description: 'Summarise long markdown documents into bullet points or short paragraphs.',
    stars: 340,
    risk: 'low',
    status: 'installed',
    sha256: 'abcdef0123456789abcdef0123456789abcdef0123456789',
    author: 'clawhub/markdown-summarise',
    lastUsed: '1 week ago',
    icon: 'ScrollText',
    tools: [
      {
        name: 'summarise',
        summary: 'Summarise markdown into bullets or paragraphs',
        inputSchemaPreview: '{ text: string, format?: "bullets" | "paragraph" }',
        sideEffects: { reads: true },
        humanApprovalRequired: true,
      },
    ],
    audit: [],
    versions: [{ version: '1.0.4', approvedAt: '2026-02-28' }],
  },

  // ===== PENDING REVIEW =====
  {
    id: 'gmail-cleanup-agent',
    slug: 'gmail-cleanup-agent',
    name: 'Gmail Cleanup Agent',
    version: '0.9.1',
    domain: 'Communication',
    description:
      'Auto-archive, label, and delete promotional emails using rules and ML. Requires broad Gmail scopes.',
    stars: 420,
    risk: 'high',
    status: 'pending-review',
    sha256: '7890abcdef1234567890abcdef1234567890abcdef123456',
    author: 'clawhub/gmail-cleanup',
    icon: 'Mail',
    tools: [
      {
        name: 'archive_promotional',
        summary: 'Archive emails matching promotional heuristics',
        inputSchemaPreview: '{ lookbackDays?: number, dryRun?: boolean }',
        sideEffects: { reads: true, writes: true, network: true },
        humanApprovalRequired: true,
      },
    ],
    securityReview: {
      verdict: 'suspicious',
      confidence: 'medium',
      model: 'claude-haiku-4-5',
      dimensions: [
        { key: 'purpose_matches_claims', label: 'Purpose matches claims', rating: 'ok' },
        { key: 'instruction_scope', label: 'Instruction scope', rating: 'note', note: 'Broad mailbox access' },
        { key: 'install_mechanism_safe', label: 'Install mechanism safe', rating: 'ok' },
        {
          key: 'credential_proportionality',
          label: 'Credential proportionality',
          rating: 'warn',
          note: 'Requests delete scope for a read-heavy workflow — disproportional',
        },
        { key: 'zenbot_env_exposure', label: 'ZenBot env exposure', rating: 'note', note: 'Reads OAuth session' },
      ],
    },
  },
  {
    id: 'calendar-bulk-move',
    slug: 'calendar-bulk-move',
    name: 'Calendar Bulk Move',
    version: '1.2.0',
    domain: 'Productivity',
    description:
      'Move or reschedule many calendar events in one pass. Useful for weekly planning and conflict resolution.',
    stars: 156,
    risk: 'medium',
    status: 'pending-review',
    sha256: '456789abcdef0123456789abcdef0123456789abcdef0123',
    author: 'clawhub/calendar-bulk-move',
    icon: 'Calendar',
    tools: [
      {
        name: 'bulk_move',
        summary: 'Move multiple events by a duration offset or to a new slot',
        inputSchemaPreview: '{ eventIds: string[], offset?: string, toSlot?: string }',
        sideEffects: { reads: true, writes: true, network: true, userFacing: true },
        humanApprovalRequired: true,
      },
    ],
    securityReview: {
      verdict: 'clean',
      confidence: 'high',
      model: 'claude-haiku-4-5',
      dimensions: [
        { key: 'purpose_matches_claims', label: 'Purpose matches claims', rating: 'ok' },
        { key: 'instruction_scope', label: 'Instruction scope', rating: 'ok' },
        { key: 'install_mechanism_safe', label: 'Install mechanism safe', rating: 'ok' },
        { key: 'credential_proportionality', label: 'Credential proportionality', rating: 'ok' },
        { key: 'zenbot_env_exposure', label: 'ZenBot env exposure', rating: 'ok' },
      ],
    },
  },

  // ===== DISCOVERED =====
  {
    id: 'yt-transcript',
    slug: 'yt-transcript',
    name: 'YouTube Transcript',
    version: '2.1.0',
    domain: 'Media',
    description: 'Fetch transcripts for any YouTube video. Supports auto-generated and human-uploaded captions.',
    stars: 680,
    risk: 'low',
    status: 'discovered',
    sha256: 'deadbeef1234567890abcdef1234567890abcdef12345678',
    author: 'clawhub/yt-transcript',
    icon: 'Youtube',
    tools: [],
  },
  {
    id: 'image-generate-openai',
    slug: 'image-generate-openai',
    name: 'Image Generate (OpenAI)',
    version: '1.4.2',
    domain: 'Media',
    description: 'Generate images with DALL-E 3. Bring your own API key.',
    stars: 1520,
    risk: 'medium',
    status: 'discovered',
    sha256: '0123456789abcdef0123456789abcdef0123456789abcdef',
    author: 'clawhub/image-generate-openai',
    icon: 'Image',
    tools: [],
  },
  {
    id: 'playwright-screenshot',
    slug: 'playwright-screenshot',
    name: 'Playwright Screenshot',
    version: '3.0.1',
    domain: 'Web',
    description: 'Capture full-page screenshots of any URL using a headless browser.',
    stars: 1200,
    risk: 'medium',
    status: 'discovered',
    sha256: '98765432109876543210fedcba9876543210fedcba987654',
    author: 'clawhub/playwright-screenshot',
    icon: 'Camera',
    tools: [],
  },
  {
    id: 'csv-transform',
    slug: 'csv-transform',
    name: 'CSV Transform',
    version: '1.1.0',
    domain: 'Data',
    description: 'Filter, reshape, and transform CSV files with a small expression language.',
    stars: 250,
    risk: 'low',
    status: 'discovered',
    sha256: 'aaaabbbbccccddddeeeeffff0000111122223333444455556',
    author: 'clawhub/csv-transform',
    icon: 'Rows',
    tools: [],
  },
  {
    id: 'github-release-notes',
    slug: 'github-release-notes',
    name: 'GitHub Release Notes',
    version: '0.7.3',
    domain: 'Developer',
    description: 'Generate release notes from a range of commits or PRs in a GitHub repository.',
    stars: 410,
    risk: 'medium',
    status: 'discovered',
    sha256: 'ffee00ddcc00aabb9988776655443322110011223344556',
    author: 'clawhub/github-release-notes',
    icon: 'GitBranch',
    tools: [],
  },
  {
    id: 'notion-export',
    slug: 'notion-export',
    name: 'Notion Export',
    version: '2.0.5',
    domain: 'Documents',
    description: 'Export Notion pages and databases to markdown or HTML.',
    stars: 520,
    risk: 'low',
    status: 'discovered',
    sha256: 'cafebabedeadbeef0123456789abcdef0123456789abcdef',
    author: 'clawhub/notion-export',
    icon: 'Notebook',
    tools: [],
  },
]
